import "./AppName.scss";

import React from "react";

const AppName = ({ width = "96px", color = "#fff" }) => {
  return (
    <span
      className="hallapp-appnameH"
      style={{ "--w": width, "--c": color }}
      aria-label="HallApp"
      role="img"
    >
      <i className="hallapp-appnameH__bar" aria-hidden="true" />
    </span>
  );
};

export default AppName;
